export const imagesConstants = [
  {
    className: "about-page_flower-img",
    src: "./img/flowerAndBook.webp",
    alt: "flower and book",
  },
  {
    className: "about-page_opposite-flower-img",
    src: "./img/oppositeFlowerAndBook.jpg",
    alt: "flower and book",
  },
  {
    className: "about-page_profile-img",
    src: "./img/profile.jpg",
    alt: "profile image",
  },
];
